const data = [
  {
    id: 1,
    image: "https://img.icons8.com/ios/64/000000/menu.png",
    title: "Full-Stack Development",
    desc: "Building dynamic web applications using MongoDB, Express.js, React, and Node.js.",
  },
  {
    id: 2,
    image: "https://img.icons8.com/ios/64/000000/open-book.png",
    title: "Frontend Development",
    desc: "Creating responsive and engaging user interfaces with React and modern JavaScript.",
  },
  {
    id: 3,
    image:
      "https://img.icons8.com/fluency-systems-regular/64/000000/retro-tv.png",
    title: "Backend Development",
    desc: "Developing robust server-side applications with Node.js and Express.js.",
  },
  {
    id: 4,
    image: "https://img.icons8.com/material-outlined/64/000000/topic--v1.png",
    title: "Mobile App Development",
    desc: "Designing and developing mobile applications using React Native.",
  },
  {
    id: 5,
    image: "https://img.icons8.com/ios-filled/64/000000/wifi.png",
    title: "API Integration",
    desc: "Integrating third-party APIs to enhance application functionality and performance.",
  },
  {
    id: 6,
    image: "https://img.icons8.com/glyph-neue/64/000000/polyline.png",
    title: "Personal Projects",
    desc: "Showcasing various personal projects that demonstrate my skills in MERN stack development.",
  },
];
export default data;
